import React from 'react';
import enhance from './enhance';
import styles from './styles.scss';
import srcAlertIconWhite from './alert-icon-white.svg';
import srcBtnX from './btn-x.svg';
import AnnouncementMessage from './AnnouncementMessage';
import { Link } from 'react-router-dom';
import { orderDashboardPath } from 'utils/paths';

export const Announcement = ({
  onClickClose,
  readAcknowledge,
  readMessages,
  unreadMessages,
  hasUnread,
  displayReadMessages,
  showPreviousMessages,
  prevReadMessagesLink,
  showPrevMessagesLabel,
  proceedLabel,
  announcementLabel,
  iconContainerStyle,
  headerContainerStyle,
  buttonStyle,
}) => (
  <div className={styles.announcementView}>
    <div
      style={headerContainerStyle}
      className={styles.announcementHeaderContainer}
    >
      <div style={iconContainerStyle} className={styles.iconContainer}>
        <img src={srcAlertIconWhite} alt="" className={styles.icon} />
      </div>
      <div className={styles.announcementHeader}>
        <h1 className={styles.title}>{announcementLabel}</h1>
        {!hasUnread && (
          <Link to={orderDashboardPath}>
            <img src={srcBtnX} alt="" className={styles.closeIcon} />
          </Link>
        )}
      </div>
    </div>
    <div className={styles.announcementBody}>
      <div className={styles.sidenav} />
      <div>
        <div className={styles.announcements}>
          {hasUnread && (
            <div>
              {unreadMessages.map(announcement => (
                <AnnouncementMessage
                  key={announcement.id}
                  announcement={announcement}
                />
              ))}
              <div className={styles.proceedContainer}>
                <span>{readAcknowledge}</span>
                <button
                  onClick={onClickClose}
                  style={buttonStyle}
                  className={styles.button}
                >
                  {proceedLabel}
                </button>
              </div>
            </div>
          )}
          {prevReadMessagesLink && (
            <div className={styles.showPrevContainer}>
              <button
                style={buttonStyle}
                className={styles.showPrevLink}
                onClick={showPreviousMessages}
              >
                {showPrevMessagesLabel}
              </button>
            </div>
          )}
          {displayReadMessages && (
            <div>
              {readMessages.map(announcement => (
                <AnnouncementMessage
                  key={announcement.id}
                  announcement={announcement}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

export default enhance(Announcement);
